import React, { Component, useEffect, useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const ListLeaves = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	const emptyUser={
		url_name: "",
		url_link: "",
		parent: ""
	}

	const [user, setUser] = useState({
		url_name: "",
		url_link: "",
		parent: ""
	})

	const handelInput = (event) => {
		event.preventDefault();
		const { name, value } = event.target;
		console.log(name, value)
		setUser({ ...user, [name]: value });
	}



	
	const history = useHistory();
	const [data, setData] = useState([]);
	const [datacount, setDataCount] = useState([]);
	const [dataval, setdataval] = useState([]);
	const [currentPageId, setCurrentPageId] = useState(1);


	// const [anand, setAnand]= useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	// const itemsPerPage = 10;
	const indexOfLastItem = currentPage * itemsPerPage;
	const indexOfFirstItem = indexOfLastItem - itemsPerPage;
	let filteredItems = data.filter((item) =>



		`${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}${item.department_name.toLowerCase()}`.includes(searchTerm.toLowerCase())

	);
	const filteredData = filteredItems.slice(indexOfFirstItem, indexOfLastItem);
	const startIndex = (currentPage - 1) * itemsPerPage;

	useEffect(() => {
		setCurrentPage(1);
	}, [searchTerm]);

	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const handleSearch = (event) => {
		setSearchTerm(event.target.value);
	};


	const clearInput = () => {
		setSearchTerm("");
	  };


	const handleRowsPerPageChange = (e) => {
		setItemsPerPage(Number(e.target.value));
		setCurrentPage(1); // Reset to first page
	};



	useEffect(() => {
		axios.get(API_BASE_URL + '/floor_payslip_list', {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		})


			.then(res => setData(res.data))
			// .then(res => console.log(res.data))
			.catch(err => console.log(err));
	}, [])





	var elements = [];
	for (var i = 1; i <= datacount.total_page; i++) {
		elements.push(i);
	}

	//   for(var i=1;i<=datacount.total_page;i++){
	// 	elements.push(<li className="page-item"><a className="page-link" href="" onClick={() => handlePagination(i)}>
	// 	  {i}
	//   </a></li>);
	// }

	//console.log(elements)

	//   const [currentPage,setCurrentPage]= useState(1);
	const recordsPerPage = 10;

	const lastIndex = currentPage * recordsPerPage;
	const firstIndex = lastIndex - recordsPerPage;
	const records = data.slice(firstIndex, lastIndex);
	const npage = Math.ceil(data.length / recordsPerPage);
	const numbers = [...Array(npage + 1).keys()].slice(1);




	



	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />
							{/* <div className="d-flex justify-content-between align-items-center mb-3">
								<div className="header-action">
									<div id="button">
										<button style={{ float: 'center' }}
											type="button"
											className="btn btn-primary"
											data-toggle="modal"
											data-target="#exampleModal"
											onClick={()=>{setUser(emptyUser)}}
										>
											<i className="fe fe-plus mr-2" />
											Add
										</button>
									</div>
								</div>
							</div> */}

						</div>
					</div>


					<div className="section-body">
						<div className="container-fluid">
							<div className="tab-content">
								<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
									<div className="card">
										<div className="card-header">
											<h3 className="card-title" style={{ color: '#e96827' }}>List All Payslip Request</h3>
											<div className="card-options" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px' }}>

												<div className="input-group">

													<select style={{
														padding: '8px',
														marginRight: '20px',
														borderRadius: '4px',
														border: '1px solid #ccc',
														backgroundColor: '#BCD1DB', display: 'flex', justifyContent: 'left'
													}}
														id="rowsPerPage"
														value={itemsPerPage}
														onChange={handleRowsPerPageChange}
													>
														<option value={10}>10</option>
														<option value={25}>25</option>
														<option value={50}>50</option>
														<option value={100}>100</option>
													</select>

													<div style={{ position: "relative", width: "300px" }}>

													<input
														type="text"
														className="form-control form-control-sm"
														placeholder="Search"
														value={searchTerm}
														onChange={handleSearch} 
														style={{
															width: "100%",
															padding: "10px",
															paddingRight: "30px", // Extra space for the clear icon
															boxSizing: "border-box",
														  }}
														// style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }}
													/>

 {searchTerm.length>0 && ( 
        <span
          onClick={clearInput}
          style={{
            position: "absolute",
			top: "50%",
			right:"10px",
			transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#aaa",
            fontSize: "18px",
			// marginLeft: '260px !important',
            
          }}
        >
          ✖
        </span>
       )}
	    </div>



												</div>

											</div>
										</div>












										<div className="card-body">
											<div className="table-responsive">
												<table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
													<thead>
														<tr>
															<th>Action</th>
															<th>Payment Id</th>
                                                            <th>Employee ID</th>
															<th>Employee</th>
															<th>Department</th>
                                                            <th>Payslip Month</th>
															<th>Applied On</th>
															<th>Reason</th>
															<th>Incharge</th>
															<th>Hod</th>
															<th>HR</th>
														</tr>
													</thead>
													<tbody>



														{
															filteredData.map((flrpayslip, index) => {

																return <tr key={index}>
																	<td className="d-flex">
																		
																		<Link to={`/payslip-request?id=${flrpayslip.request_id}`}>
																		<i className="fe fe-maximize" />
																		</Link>
																		
																	

																	</td>
																	<td>
																		<span>{flrpayslip.payment_id_number}</span>
																	</td>
																	<td>
																		<span>{flrpayslip.employee_id}</span>
																	</td>
																	<td>
																		<span>{flrpayslip.employee_name}</span>
																	</td>
																	<td>
																		<span>{flrpayslip.department_name}</span>
																	</td>

																	<td>
																		<span>{flrpayslip.month_payment}</span>
																	</td>


																	<td>
																		<span>{flrpayslip.applied_on}</span>
																	</td>

																	<td>
																		<span>{flrpayslip.reason}</span>
																	</td>

																

																	<td>
																		<span>{ReactHtmlParser(flrpayslip.incharge_status)}</span>
																	</td>


																	<td>
																		<span>{ReactHtmlParser(flrpayslip.hod_status)}</span>
																	</td>

																	<td>
																		<span>{ReactHtmlParser(flrpayslip.hr_status)}</span>
																	</td>

																	
																</tr>


															})
														}

													</tbody>
												</table>
											</div>



											<nav aria-label="Page navigation">
												<ul className="pagination mb-0 justify-content-end">
													<li className="page-item"><button className="page-link"
														key={'f'}
														// style={{
														//   backgroundColor: currentPage ===  1 && "lightgreen",
														// }}
														onClick={() => paginate(1)}
													>
														First
													</button></li>

													{Array.from(
														{ length: Math.ceil(filteredItems.length / itemsPerPage) },
														(_, index) => (
															<li className="page-item">
																<button className="page-link"
																	key={index + 1}
																	// style={{
																	//   backgroundColor: currentPage === index + 1 && "lightgreen",
																	// }}
																	onClick={() => paginate(index + 1)}
																>
																	{index + 1}
																</button></li>
														)
													)}

													<li className="page-item">
														<button className="page-link"
															key={'l'}
															// style={{
															//   backgroundColor: currentPage ===  Math.ceil(filteredItems.length / itemsPerPage) && "lightgreen",
															// }}
															onClick={() => paginate(Math.ceil(filteredItems.length / itemsPerPage))}
														>
															Last
														</button></li>






													{/* <li className="page-item">
												<button className="page-link"onClick={() => {handlePagination(1);setCurrentPageId(1)}}>
													Prev
												</button>
											</li>
											
											{elements.map((e)=>{
return(
	<li className="page-item"><button className="page-link"  onClick={() => {handlePagination(e);setCurrentPageId(e)}}>
		  {e}
	  </button></li>
)
											})}
											
											
											

											

										
											
											
											<li className="page-item">
												<button className="page-link"onClick={() => {handlePagination(datacount.total_page);setCurrentPageId(datacount.total_page)}}>
													Last
												</button>
											</li> */}
												</ul>
											</nav>









										</div>
									</div>
								</div>


							</div>
						</div>
					</div>

				</div>
			</div>





			
			






		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(ListLeaves);